import type { FormField } from '@cli-types/core-engine/schema.js'
import { FORM_LAYOUT_TYPES } from '@cli-constants/schema.js'

export function isPersistedFormField(field: FormField): boolean {
  return !FORM_LAYOUT_TYPES.has(field.type)
}
